import { HTTPClient } from "../common/HTTPClient";
import { PaginationRequestParams } from "@/common/mixins/pagination";

export interface CreateDeliveryRawStatusRequestParams {
  deliveryId: number;
  status: RawStatus[];
}

export interface RawStatus {
  status: string;
  name: string;
}

export interface UpdateDeliveryRawStatusRequestParams {
  deliveryId: number;
  status: RawStatus[];
}

export class RawStatusMappingClient {
  constructor(private httpClient: HTTPClient) {}

  public async getDeliveryRawStatusByDeliveryId(
    deliveryId: number
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/delivery-raw-status-mapping/delivery/${deliveryId}`,
      method: "GET"
    });

    return data;
  }

  public async postDeliveryRawStatus(
    params: CreateDeliveryRawStatusRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/delivery-raw-status-mapping",
      method: "POST",
      data: params
    });

    return data;
  }

  public async patchDeliveryRawStatus(
    params: UpdateDeliveryRawStatusRequestParams
  ): Promise<any> {
    const { deliveryId, ...body } = params;
    const { data } = await this.httpClient.request({
      url: `/delivery-raw-status-mapping/${deliveryId}`,
      method: "PATCH",
      data: body
    });

    return data;
  }
}
